import {Image, View} from "react-native";
import {Layout, Text} from "@ui-kitten/components";
import * as React from "react";
import {Bold} from "../../../shared/bold";
import {TransparentBox} from "../../../ui/transparent-box";

export function WecyclePresentation() {
    return <Layout level='2' style={{
        backgroundColor: 'transparent',
        padding: 20
    }}>
        <TransparentBox>
            <View style={{alignItems: "center"/*, marginTop: -35*/}}>
                <Image style={{height: 80, aspectRatio: 50 / 50}}
                       source={require("../../../../assets/images/logo-wecycle-solo.png")} />
            </View>

            <Text style={{color: 'white', fontSize: 25, lineHeight: 25, marginTop: 10, marginBottom: 20, textAlign: "center"}}>WeCycle</Text>
            <Text style={{color: 'white', marginBottom: 10, lineHeight: 25, textAlign: 'center'}}><Text style={{fontWeight: 'bold', color: '#a0c946'}}>Collection</Text> of your recycling bin directly from your doorstep</Text>
        </TransparentBox>
    </Layout>;
}